export const declOfNum = (number, titles) => {
  var c = [2, 0, 1, 1, 1, 2];
  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : c[number % 10 < 5 ? number % 10 : 5]];
};
export const getTimeFormatted = (time) => {
  const hours = Math.floor(time / 60 / 60);
  const min = Math.floor(time / 60) - (hours * 60);
  const sec = time % 60;
  return (!hours ? '' : hours + 'ч. ') + (!min && !hours ? '' : min + 'м. ') + sec + 'с.';
}

export const optionsTimeHumanize = {
  ruOnlyHoursAndMinutes: { language: "ru", units: ["h", 'm'], maxDecimalPoints: 1, decimal: "." },
  ruLargest3: { language: "ru", largest: 3, }, // round: true,
  ruOnlyHours: { language: "ru", units: ["h"], maxDecimalPoints: 1, decimal: ".", },
  ruOnlyHoursShort: { language: "shortRu", languages: { shortRu: { h: () => "ч", } }, units: ["h"], maxDecimalPoints: 1, decimal: ".", },
}

export function addTooltips($) {
  const groupsSegments = ['inactive', 'simple_active', 'calls', 'messages', 'meeting', 'lunch_time']

  for (const group of groupsSegments) {
    $(`.segment-item`).hover(
      function (e) {
        var s = $(this).closest('.user').children('.tooltip-wrap');
        var tooltip = s.children('.tooltip');

        const type = $(this).attr('data-type')
        const time = $(this).attr('data-time')
        const group = $(this).attr('data-group')

        tooltip.removeClass('tooltip-none').addClass(`tooltip-${group}`);
        tooltip.html(`${(type ? type + '<br>' + time : time)}`)


        var left = 0;
        var o = s.offset().left;
        var m = e.pageX - 10;
        if (m > o) {
          left = m - o;
        }
        if (left + tooltip.outerWidth() > s.outerWidth()) {
          left = left - (left + tooltip.outerWidth() - s.outerWidth());
        }
        tooltip.css({ left: left + 'px' });
      },
      function () {
        $(this)
          .closest('.user')
          .find('.tooltip')
          .addClass('tooltip-none')
          .removeClass(`tooltip-${group}`)
      }
    );
  }
}

export const changeStatTimeFormatFroTabletMediaQuery = (vueComponent) => {
  const mediaQueryMore768 = window.matchMedia('(min-width: 769px)');
  function handleTabletChange(e) {
    if (e.matches) {
      vueComponent.optionsTimeHumanize.forStat = vueComponent.optionsTimeHumanize.forStatLong;
    } else {
      vueComponent.optionsTimeHumanize.forStat = vueComponent.optionsTimeHumanize.forStatShort;
    }
  }
  mediaQueryMore768.addListener(handleTabletChange);

  if (window.innerWidth >= 768) {
    vueComponent.optionsTimeHumanize.forStat = vueComponent.optionsTimeHumanize.forStatLong;
  } else {
    vueComponent.optionsTimeHumanize.forStat = vueComponent.optionsTimeHumanize.forStatShort;
  }
}

export const getParamsFromURL = (url = window.location.search) => {
  const urlParams = new URLSearchParams(url)
  const params = {}
  params.accountId = Number(urlParams.get('c')) || null
  params.password = urlParams.get('p') || null
  params.day = urlParams.get('day') || null
  params.dayFrom = urlParams.get('day_from') || null
  params.dayTo = urlParams.get('day_to') || null
  params.users = urlParams.get('users') ? urlParams.get('users').split(',').map(Number) : null
  params.eventTypes = urlParams.get('et') ? urlParams.get('et').split(',').map(Number) : null

  return params
}

export const getParamsFromLocalStorage = (url = window.location.search, storageScope = null) => {
  const urlParams = new URLSearchParams(url)
  const paramsFromUrl = getParamsFromURL(url)
  const authParams = {
    accountId: Number(urlParams.get('c')) || null,
    password: urlParams.get('p') || null
  }

  const cacheScope = storageScope || authParams.accountId
  const paramsFromCache = localStorage.getItem(`PANEL_ACTIVITY_COPY${cacheScope}_settings`)
  const paramsOld = paramsFromCache ? JSON.parse(paramsFromCache) : {}

  const params = {
    day: paramsFromUrl.day || paramsOld.day || null,
    dayFrom: paramsFromUrl.dayFrom || paramsOld.dayFrom || paramsOld.day || null,
    dayTo: paramsFromUrl.dayTo || paramsOld.dayTo || paramsOld.day || null,
    users: paramsFromUrl.users || paramsOld.users || null,
    eventTypes: paramsFromUrl.eventTypes || paramsOld.eventTypes || null
  }

  return { authParams, params }
}
export const setParamsFromLocalStorage = (accountId, params) => {
  localStorage.setItem(`PANEL_ACTIVITY_COPY${accountId}_settings`, JSON.stringify(params))
}

export const setParamsToURL = (params) => {
  const urlParams = new URLSearchParams()

  const mapNameToKey = {
    accountId: 'c',
    password: 'p',
    day: 'day',
    dayFrom: 'day_from',
    dayTo: 'day_to',
    users: 'users',
    eventTypes: 'et',
  }
  for (const key in params) {
    if (params[key]) {
      urlParams.append(mapNameToKey[key], params[key])
    }
  }
  // console.log(urlParams.toString());
  return urlParams.toString()
}

export const getPercent = (a, b) => Math.round((a / b) * 100) || 0
